import moment from 'moment';
import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { IReducer } from '../../../../../../../redux/configureStore';
import {
  agencyAccountMask,
  cpfCnpjMask,
} from '../../../../../../../utils/masks';
import FiduciaPdf from '../components/FiduciaPdfComponents';

interface IPdfBody {
  body: any | undefined;
  title: string | undefined;
  isLastTwelveMonths: boolean | undefined;
}

function PdfBody(props: IPdfBody) {
  const faresFilterState = useSelector(
    (reducer: IReducer) => reducer.faresFilter
  );

  const boletoFaresState = useSelector(
    (reducer: IReducer) => reducer.boletoFares
  );

  const monthlyFareState = useSelector(
    (reducer: IReducer) => reducer.monthlyFares
  );

  const partnerList = useSelector(
    (reducer: IReducer) => reducer.clientsApp.partnersList
  );

  let subtitle = useMemo(() => {
    switch (boletoFaresState.account || monthlyFareState.accounts.type) {
      case 'pf':
        return 'Movimento - Pessoa Física';
      case 'pj':
        return 'Movimento - Pessoa Jurídica';
      case 'todos':
        return 'Global';
      case 'consignada':
        return 'Consignada';
      case 'escrow':
        return 'Escrow';
      case 'tib':
        return 'TIB';
      default:
        break;
    }
    return '';
  }, [boletoFaresState.account, monthlyFareState.accounts]);

  const partner = useMemo(() => {
    let value: any = 'Global';
    partnerList.filter((element: any) => {
      const id = element.id.toString();
      if (id === faresFilterState.partner) {
        value = element;
      }
      return value;
    });
    return value;
  }, [faresFilterState.partner, partnerList]);

  switch (boletoFaresState.account) {
    case 'pf':
      subtitle = 'Movimento - Pessoa Física';
      break;
    case 'pj':
      subtitle = 'Movimento - Pessoa Jurídica';
      break;
    case 'todos':
      subtitle = 'Global';
      break;
    case 'consignada':
      subtitle = 'Consignada';
      break;
    case 'escrow':
      subtitle = 'Escrow';
      break;
    case 'TIB':
      subtitle = 'TIB';
      break;

    default:
      break;
  }

  switch (monthlyFareState.accounts.type) {
    case 'pf':
      subtitle = 'Movimento - Pessoa Física';
      break;
    case 'pj':
      subtitle = 'Movimento - Pessoa Jurídica';
      break;
    case 'todos':
      subtitle = 'Global';
      break;
    case 'consignada':
      subtitle = 'Consignada';
      break;
    case 'escrow':
      subtitle = 'Escrow';
      break;
    case 'TIB':
      subtitle = 'TIB';
      break;

    default:
      break;
  }

  return (
    <>
      <FiduciaPdf.Title>{props.title}</FiduciaPdf.Title>
      <FiduciaPdf.Subtitle>
        {faresFilterState.fare !== 'mensalidade' &&
        faresFilterState.fare !== 'boleto'
          ? ''
          : subtitle}
      </FiduciaPdf.Subtitle>
      <FiduciaPdf.SubValues>
        {props.isLastTwelveMonths
          ? `${moment(faresFilterState.finalDate)
              .subtract(1, 'year')
              .format('MM/YYYY')} até ${moment(
              faresFilterState.finalDate
            ).format('MM/YYYY')}`
          : `${moment(faresFilterState.initialDate).format(
              'DD/MM/YYYY'
            )} até ${moment(faresFilterState.finalDate).format('DD/MM/YYYY')}`}
      </FiduciaPdf.SubValues>

      <FiduciaPdf.Content style={{ fontSize: '1.5rem' }}>
        <FiduciaPdf.ContainerLabelValues>
          <FiduciaPdf.Label>Parceiro consultado:</FiduciaPdf.Label>
          <FiduciaPdf.Values isActive>
            {partner !== 'Global'
              ? `Razão Social: ${partner.razao_social}`
              : partner}
          </FiduciaPdf.Values>
          <FiduciaPdf.Values isActive={partner !== 'Global'}>
            {partner !== 'Global'
              ? `CPF/CNPJ: ${cpfCnpjMask(partner.cnpj)}`
              : ''}
          </FiduciaPdf.Values>

          <FiduciaPdf.Values isActive={partner !== 'Global'}>
            {partner !== 'Global'
              ? `Responsável: ${partner.nome_responsavel}`
              : ''}
          </FiduciaPdf.Values>

          <FiduciaPdf.Values isActive={partner !== 'Global'}>
            {partner !== 'Global'
              ? `Conta/Agência: ${agencyAccountMask(
                  partner.agencia,
                  partner.conta,
                  partner.digito
                )}`
              : ''}
          </FiduciaPdf.Values>
        </FiduciaPdf.ContainerLabelValues>

        {props.body}
      </FiduciaPdf.Content>
    </>
  );
}

export default PdfBody;
